"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
const React = require("react");
const Sentry = require("@sentry/browser");
// local
const ErrorPlaceholder_1 = require("../ErrorPlaceholder");
if (env.sentryDsn === undefined) {
    console.warn("cannot log errors");
}
/**
 * Wrap this component around other children. When an error occurs in any
 *  child component this will then show an error page and log the error that
 *  occurred to sentry.io.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.initialState = {
            error: undefined
        };
        this.state = this.initialState;
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        // log error to sentry if we are not in local mode
        // also show sentry report dialog if user has enabled it
        if (env.sentryEnvironment !== "local") {
            Sentry.withScope(scope => {
                scope.setExtra("componentStack", info);
                const eventId = Sentry.captureException(error);
                if (this.props.showReportDialog) {
                    Sentry.showReportDialog({ eventId });
                }
            });
        }
    }
    render() {
        const { children, retry: fallbackRetry, catches } = this.props;
        let retry;
        if (this.state.error) {
            // check if in catches
            Array.isArray(catches) &&
                catches.map(c => {
                    if (this.state.error instanceof c.error) {
                        retry = c.retry;
                    }
                });
            if (retry === undefined) {
                retry = fallbackRetry;
            }
            return (React.createElement(ErrorPlaceholder_1.ErrorPlaceholder, { retry: retry
                    ? async () => {
                        // run the passed retry function
                        await retry();
                        // reset error state
                        // this may just re-render the error page if the same
                        // error continues
                        this.setState(this.initialState);
                    }
                    : undefined }));
        }
        return children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
//# sourceMappingURL=index.js.map